// /store/clock-store.ts
import { useSyncExternalStore } from 'react';

let currentDate = new Date();
const listeners = new Set<() => void>();
let timeoutId: ReturnType<typeof setTimeout> | null = null;

/**
 * Kolik zbyva do nejblizsi cele sekundy.
 *
 * Nikdy nevraci 0 — nulove zpozdeni by znamenalo druhy tik v teze milisekunde
 * a hodiny by se roztocily naprazdno.
 */
function doCeleSekundy(): number {
    const zbyva = 1000 - (Date.now() % 1000);
    return zbyva === 0 ? 1000 : zbyva;
}

function naplanuj() {
    timeoutId = setTimeout(tick, doCeleSekundy());
}

function tick() {
    currentDate = new Date();
    // Naplanovat DRIV, nez se rozbehne prekresleni. Cas dalsiho tiku se tim odvozuje
    // od hodin, ne od toho, jak dlouho render trval — a pripadne zpozdeni se navic
    // samo srovna, protoze se poradi vzdy podle aktualniho Date.now().
    naplanuj();
    for (const listener of listeners) {
        listener();
    }
}

function spustHodiny() {
    if (timeoutId === null && listeners.size > 0) {
        // Kdyz hodiny chvili stály (vsichni odberatele byli odpojeni), je `currentDate`
        // zastaraly a prvni render by ukazal starou sekundu. useSyncExternalStore si po
        // navratu ze `subscribe` snapshot znovu overuje, takze tohle si React vsimne.
        currentDate = new Date();
        naplanuj();
    }
}

function zastavHodiny() {
    if (timeoutId !== null && listeners.size === 0) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
}

/**
 * MODULOVE konstanty, ne inline funkce v hooku.
 *
 * Driv byly obe definovane primo ve `useClock`, takze mely pri KAZDEM renderu novou
 * identitu. `useSyncExternalStore` se kvuli tomu po kazdem renderu odhlasil a znovu
 * prihlasil — a protoze se pri odhlaseni posledniho posluchace hodiny zastavi a pri
 * prihlaseni rozbehnou znovu, zacinala perioda pokazde od nuly. Efektivni perioda tedy
 * nebyla 1 s, ale 1 s + doba renderu: na poplachove obrazovce s mapou a desitkami karet
 * casovace viditelne preskakovaly cele sekundy, a to u VSECH naraz (hlavni casovka
 * i odpocty dojezdu), protoze sdileji tyhle hodiny.
 *
 * Se stabilni identitou se React prihlasi jednou pri mountu a hodiny bezi nepreruseně.
 */
const subscribe = (listener: () => void) => {
    listeners.add(listener);
    spustHodiny();
    return () => {
        listeners.delete(listener);
        zastavHodiny();
    };
};

const getSnapshot = () => currentDate;

export function useClock(): Date {
    return useSyncExternalStore(subscribe, getSnapshot);
}

/** Jen pro testy — kolik odberatelu prave posloucha. */
export function __pocetPosluchacu(): number {
    return listeners.size;
}

/** Jen pro testy — bezi prave ted naplanovany tik? */
export function __hodinyBezi(): boolean {
    return timeoutId !== null;
}
